export const userTokenName = 'token';
export const siteInfo = 'siteInfo';
export const companyName = "companyName";
export const cmNavMenu = 'cmNavMenu';
export const loginRole = 'loginRole';
export const loginUser = 'loginUser';
export const breadcrumb = 'breadcrumb';
export const faDictMap = { faStatus: 'faStatus', faResult: 'faResult', faWay: 'faWay' };
export const inDictMap = { inStatus: 'inStatus', inResult: 'inResult', inReason: 'inReason' };